import styled from '@emotion/styled'
import { ParallaxImage } from 'components/Parallax'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const SecurityHeroImage = styled(ParallaxImage)`
  object-fit: cover;
  position: absolute;
  left: 4rem;
  top: ${pxToRem(120)}rem;
  width: 45%;
  z-index: -1;
  height: 85%;
  @media ${BREAKPOINTS.MD.max} {
    top: unset;
    bottom: 100%;
    width: 80%;
    left: 50%;
    transform: translateX(-50%);
    max-height: 13rem;
    object-fit: cover;
    object-position: center 56%;
  }
`
export const SecurityHeroContentWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  margin: 0 var(--p-content);
  position: relative;
  @media ${BREAKPOINTS.MD.max} {
    margin-top: 13rem;
  }
`

export const SecurityHeroContent = styled.div`
  display: flex;
  align-items: flex-end;
  width: calc(50% - 5.625rem);
  margin-top: ${pxToRem(100)}rem;

  @media ${BREAKPOINTS.MD.max} {
    width: 100%;
  }
`

export const SecurityHeroContentBox = styled.div`
  position: relative;
  padding: 43px 0;
  margin-top: 2rem;
  margin-bottom: 7.5rem;

  @media ${BREAKPOINTS.MD.min} {
    &:before {
      content: '';
      border: 2px solid var(--c-blue100);
      position: absolute;
      z-index: -1;
      top: 0;
      left: ${pxToRem(-50)}rem;
      right: -19px;
      bottom: 0;
    }
  }

  @media ${BREAKPOINTS.MD.max} {
    margin-top: 0;
    margin-bottom: 0;
    padding-top: 0;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;

    &:before {
      top: -5rem;
      bottom: 40%;
    }
  }
`
